import { Button, Checkbox, Popover, Row, Form } from 'antd';
import React, { ReactElement } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { isValidConfiguration } from '../../../modules/crm/inPatient/service/crmUtils';
import { CLAIMS_VIEW_CONFIG_SELECT_ERR, GUTTOR_SPACE_SMALL, IN_PATIENT_CONFIG_SELECT_ERR, IN_PATIENT_HORIZONTAL_CONFIG_SELECT_ERR } from '../../constants/commonConstants';
import { ReactComponent as SettingOutlined } from '../../../assets/images/svg/Setting.svg';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';

export interface ITableConfigurator {
  tableMapping: any;
  configuration: any[];
  saveClickHandler: any;
  isClaimsView?: boolean;
  isGrievancePage?: boolean;
  isViewGrievancePage?: boolean;
}

const TableConfigurator = ({
  tableMapping = {},
  configuration,
  saveClickHandler = (): any => { },
  isClaimsView = false, isGrievancePage = false, isViewGrievancePage = false}: ITableConfigurator): ReactElement => {

    const [menu, setMenu] = useState(null as any);
  const [err, setErr] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const {isPreAuthView} = useSelector((state: RootState): any => state?.selectedInPatientDetail || {});
  const appDetail: ApplicationDetailModel = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail || {});
  const isPreAuthClaimViewEnabled = appDetail.getIsPreAuthClaimViewEnabled();
  const isNewTpaDeskEnabled = appDetail.getIsNewTpaDeskEnabled();
  useEffect((): any => {
  const selectedCount = Object?.values(form?.getFieldsValue())?.filter( // to get the count of the selected form fields
      (value: any): any => value === true,
    )?.length;
    const transformedArray = Object?.entries(form?.getFieldsValue())?.map(
      ([key, value]: any): any => ({
        mappedComponent: key,
        isVisible: value,
      }),
    );

    if ((selectedCount >= 6 && selectedCount <= 8) || selectedCount === 0) {// to trigger the alert message
      Object?.keys(tableMapping)?.forEach((key: string): any => { //  based on the threshold selected fields
        const selectedMapping = transformedArray?.find(
          ({ mappedComponent }: any): boolean => mappedComponent === key,
        );
        if (selectedMapping) {
          form.setFieldsValue({ [key]: selectedMapping.isVisible });
        } else {
          form.setFieldsValue({ [key]: false });
        }
      });
    }
    getMenuItem();
  }, [configuration, isLoading, err]); // when we change the form Values if we get some error,we will run this useEffect again

  useEffect((): void => {
      Object?.keys(tableMapping)?.forEach((key: string): any => {
        const selectedMapping = configuration?.find(({ mappedComponent }: any): boolean => mappedComponent === key);
        if (selectedMapping) {
          form.setFieldsValue({ [key]: selectedMapping.isVisible });
        } else {
          form.setFieldsValue({ [key]: false });
        }
      });
    getMenuItem();
   }, [isPreAuthView]); // whenever we change the View, we need to update the menu from the local storage

   const handleSave = (): void => {
    const formValues = form.getFieldsValue();
    const isClaimsOrGrievanceView = isClaimsView || isGrievancePage || isViewGrievancePage;
    const isPreAuthAndNewTpaEnabled = isPreAuthClaimViewEnabled && isNewTpaDeskEnabled;
    const isValid = isValidConfiguration(formValues, isClaimsOrGrievanceView, isPreAuthAndNewTpaEnabled);
    if (isValid) {
      setIsVisible(false);
      setErr('');
      setIsLoading(true);
      saveClickHandler(form, setIsVisible);
    } else {
      setErr(
        (!isClaimsOrGrievanceView && isPreAuthAndNewTpaEnabled)
          ? IN_PATIENT_HORIZONTAL_CONFIG_SELECT_ERR
          : isClaimsOrGrievanceView
          ? CLAIMS_VIEW_CONFIG_SELECT_ERR
          : IN_PATIENT_CONFIG_SELECT_ERR,
      );
    }
  };

  const validateErr = (): any => {
    if (isValidConfiguration(form.getFieldsValue(), (isClaimsView || isGrievancePage || isViewGrievancePage))) {
      setErr('');
    }
  };

  const getMenuItem = (): any => {
    const configuredMenu = (
      <Form
        form={form}
        onFinish={handleSave}
      >
        {
          Object.keys(tableMapping).map((key: string): any => {
            return (
            <Form.Item key={key} name={key} valuePropName="checked" className="mt-0 mb-0">
              <Checkbox onChange={validateErr}> {tableMapping[key]?.customTitle || tableMapping[key]?.title || 'Column'} </Checkbox>
            </Form.Item>
            );
          })
        }
        {err && <div className="error-text">{err}</div>}
        <Row gutter={GUTTOR_SPACE_SMALL} className="mt-md">
          <Button type="primary" onClick={handleSave} loading={isLoading } data-testid="save-config">Save</Button>
        </Row>
      </Form>
    );
    setMenu(configuredMenu);
    setIsLoading(false);
  };

  return (
    <span className={`table-configurator ${appDetail.getIsNewTpaDeskEnabled() && `px-10 mt--4`}`}>
      <Popover
        onVisibleChange={(ev: any): void => setIsVisible(ev)}
        visible={isVisible}
        content={menu}
        trigger="click"
        placement="bottomLeft">
          <SettingOutlined className="ant-alignment-margin mouse-pointer" onClick={(): any => setIsVisible(!isVisible)}/>
      </Popover>
    </span>
  );
};

export default TableConfigurator;
